import * as Helpers from "@vocollege/app/dist/modules/VoHelpers";

class Utils {
  getUrlParam(param: string) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }
  setRedirectUrl() {
    Helpers.localStorage.remove("redirectTo");
    const redirectTo = this.getUrlParam("redirectTo");
    if (redirectTo) {
      Helpers.localStorage.set("redirectTo", redirectTo);
    }
    const currentUrl = this.getUrlParam("currentUrl");
    if (currentUrl) {
      Helpers.localStorage.set("currentUrl", currentUrl);
    }
  }
  getRedirectUrl() {
    return Helpers.localStorage.get("redirectTo");
  }
  getContentCurrentUrl() {
    return Helpers.localStorage.get("currentUrl");
  }
  removeRedirectUrl() {
    setTimeout(() => {
      Helpers.localStorage.remove("redirectTo");
      this.removeContentCurrenttUrl();
    }, 0);
  }
  removeContentCurrenttUrl() {
    setTimeout(() => {
      Helpers.localStorage.remove("currentUrl");
    }, 0);
  }
  redirect(state: any = null) {
    let redirectTo = this.getRedirectUrl();
    if (redirectTo) {
      let redirectToUrlObj = new URL(redirectTo);
      let oldUrl = this.getContentCurrentUrl();
      if (
        redirectToUrlObj.pathname.substring(1) === oldUrl &&
        state &&
        state.url &&
        oldUrl !== state.url
      ) {
        redirectTo = `${redirectToUrlObj.origin}/${state.url}`;
      }
      window.onbeforeunload = null;
      window.location.href = redirectTo;
      return true;
    }
    return false;
  }
}

let utils = new Utils();
export default utils;
